import React from 'react';
import FailedDeliveryIcon from "../../../assets/icons/FailedDeliver.svg"
import UsageAlertIcon from "../../../assets/icons/UsageAlert.svg"
import SystemAlertsIcon from "../../../assets/icons/SystemAlerts.svg"
import { useNotificationSettings } from '../hooks/useNotificationSettings';
import '../../../index.css'

const notificationOptions = [
  {
    key: 'delivery_failure_notification',
    label: 'Failed Delivery',
    description: 'Notify when transcription delivery fails',
    icon: (
      <span className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-[#EE0B0B1A] border border-[#EE0B0B]">
        <img
        src={FailedDeliveryIcon} alt="failed delivery" 
        />
      </span>
    ),
  },
  {
    key: 'usage_alert_notification',
    label: 'Usage Alert',
    description: 'Notify when approaching plan usage limit',
    icon: (
      <span className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-[#FFA00D1A] border border-[#FFA00D]">
        <img
        src={UsageAlertIcon} alt="usage alert" 
        />
      </span>
    ),
  },
  {
    key: 'system_alert_notification',
    label: 'System Alerts',
    description: 'Notify about system updates, maintenance, outages',
    icon: (
      <span className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-[#2290E21A] border border-[#2290E2]">
        <img
        src={SystemAlertsIcon} alt="system alerts" 
        />
      </span>
    ),
  },
];

function Toggle({ checked, onChange, disabled }) {
  return (
    <button
      type="button"
      className={`w-10 h-5 sm:h-6 flex items-center rounded-full px-1 transition-colors duration-200 focus:outline-none ${checked ? 'bg-[#0A2344]' : 'bg-gray-300'} ${disabled && 'cursor-not-allowed opacity-60'}`}
      onClick={onChange}
      aria-pressed={checked}
      disabled={disabled}
    >
      <span
        className={`w-3.5 sm:w-4 h-3.5 sm:h-4 bg-white rounded-full shadow transform transition-transform duration-200 ${checked ? 'translate-x-[18px]' : ''}`}
      />
    </button>
  );
}

const NotificationSettings = () => {
  const {
    settings,
    isSaving,
    errorMessage,
    isAnyBusy,
    hasChanges,
    handleToggle,
    handleSavePreferences,
    canViewNotifications,
  } = useNotificationSettings();

  return (
    <>
    <div className="bg-white rounded-xl shadow p-5 sm:p-8 w-full border border-line">
      <h2 className="text-lg font-semibold text-primary mb-1">Notification Settings</h2>
      <p className="text-xs text-gray-500 mb-6">Choose which notifications you want to receive</p>

      {errorMessage && (
        <p className="text-sm text-red-600 mb-4">{errorMessage}</p>
      )}

      <div className="space-y-4 sm:space-y-6 mb-8">
        {notificationOptions.map((option) => (
          <div key={option.key} className="flex items-start flex-col sm:flex-row justify-between gap-4 sm:gap-0 notifications">
            <div className="flex items-center flex-row gap-4 sm:gap-0 notification-option">
              {option.icon}
              <div className="sm:ml-4">
                <div className="font-semibold text-primary mb-1">{option.label}</div>
                <div className="text-xs text-content">{option.description}</div>
              </div>
            </div>
            <div className='max-sm:ml-auto'>
            <Toggle
              checked={settings[option.key]}
              onChange={() => handleToggle(option.key)}
              disabled={!!(isAnyBusy || canViewNotifications)}
            />
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-10">
        <button
          onClick={handleSavePreferences}
          disabled={isAnyBusy || !hasChanges || canViewNotifications}
          className="bg-primary text-white px-5 sm:px-7 py-2.5 sm:py-3 rounded-md font-semibold text-xs sm:text-sm shadow hover:bg-[#14325c] transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {isSaving ? 'SAVING...' : 'SAVE PREFERENCES'}
        </button>
      </div>
    </div>
    </>
  );
};

export default NotificationSettings;
